import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { getCatalogSidebarState, getCategoriesState, toggleSidebar } from '../../../../store/slices/catalogSlice';
import { setOverflowForSidebar } from '../../../../utils/helper';
import CrossBtn from '../../CrossBtn';
import Spinner from '../../Spinner';
import FilterCheckbox from '../CatalogFilterCheckbox';
import styles from './styles.module.scss';

const CatalogSidebar = () => {
    const dispatch = useDispatch();
    const { loading, categoriesList, activeCategoriesFilters } = useSelector(getCategoriesState);
    const showSidebar = useSelector(getCatalogSidebarState);
    const { t } = useTranslation();

    useEffect(() => {
        setOverflowForSidebar(showSidebar);
    }, [showSidebar]);

    return (
        <>
            <button
                className={classNames(styles.overlay, { [styles.opened]: showSidebar })}
                onClick={() => {
                    dispatch(toggleSidebar(!showSidebar));
                }}
            ></button>
            <aside className={classNames(styles.sidebar, { [styles.opened]: showSidebar })}>
                <div className={styles.head}>
                    <h3 className={styles.title}>filters</h3>
                    <CrossBtn
                        nativeClassName={styles.close}
                        onClick={() => {
                            dispatch(toggleSidebar(!showSidebar));
                        }}
                    />
                </div>
                <div className={styles.body}>
                    <div className={styles.block}>
                        <h4 className={styles.subtitle}>{t('catalog.filters.title')}</h4>
                        {loading ? (
                            <div className={styles.spinner}>
                                <Spinner widht={48} height={48} />
                            </div>
                        ) : !!categoriesList?.length ? (
                            <ul className={styles.list}>
                                {categoriesList.map((obj) => {
                                    const { id, name } = obj;
                                    const isChecked = activeCategoriesFilters.some((cat) => cat === id);
                                    return <FilterCheckbox key={id} name={name} id={id} isChecked={isChecked} />;
                                })}
                            </ul>
                        ) : (
                            <p>{t('labels.noCategory')}</p>
                        )}
                    </div>
                </div>
            </aside>
        </>
    );
};

export default CatalogSidebar;
